
/**
 * HomePage
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Page404(){

    const style = {
        height: "100%",
        width: "100%",
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center'
    }

    return <div className='wrap' style={style}>
        Page Not Found
    </div>

}